import { Injectable } from '@angular/core';
import {Headers,Http} from "@angular/http";
import {environment} from "../../environments/environment";
import { NgModel } from '@angular/forms';

@Injectable()
export class HomeService {
      private headers = new Headers({ 'Content-Type': 'multipart/form-data' });
      constructor(
        private http: Http
      ) { }

      //Fetch single target information
    getDashboardData(){
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL+'/dashboard/';
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    importUserData(pageValue){
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL+'/importcategorydata';
            this.http.post(apiURL,pageValue)
                .toPromise()
                .then(
                    res => { // Success
                        //console.log(res.json());
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }


    
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/home/home.service.ts